/**
 *
 * @param {Array} responses
 */
const getScore = (responses) => {
  return responses.reduce((accu, curr) => {
    console.log(accu);
    console.log(curr["score"] ? curr["score"] : 0);
    return accu + (curr["score"] ? curr["score"] : 0);
  }, 0);
  return responses.reduce(
    (accu, curr) => (accu + curr["score"] ? curr["score"] : 0),
    0
  );
};
export default getScore;
